
const API_BASE = process.env.REACT_APP_API_BASE;

var token = "";

export function api_authenticate(userDetails, setFormStatus, setUser) {

	setFormStatus({ message: "Signing in..." })

	const authenticate_fetch = async () => {
		const response = await fetch(API_BASE + "authenticate", {
			method: 'POST',
			headers: {
				Accept: '*/*',
				'Content-Type': 'application/json'
			},
			body: JSON.stringify({
				username: userDetails.username,
				password: userDetails.password
			})
		});
		if (response.ok) {
			const data = await response.json();
			setFormStatus({ message: "" });
			token = data.jwt
			setUser(userDetails.username)
		} else {
			setFormStatus({
				message: "Invalid username/password",
				fieldErrors: [
					"username", "password"
				]
			})
		}
	}
	authenticate_fetch();

}

/**
 * Load notepad text.
 */
export function loadNotepad(setText, setFormStatus) {

	setFormStatus({ message: "Loading..." })

	const loadNotepad_fetch = async () => {
		const response = await fetch(API_BASE + "notepad", {
			method: 'GET',
			headers: {
				Accept: '*/*',
				'Content-Type': 'text/plain',
				Authorization: 'Bearer ' + token
			}
		});
		if (response.ok) {
			const data = await response.text();
			setFormStatus({ message: "" });
			setText(data);
		} else {
			setFormStatus(
				{
					message: "Problem loading",
					error: true
				}
			);
		}
	}

	loadNotepad_fetch();

}

export function saveNotepad(setText, setFormStatus) {

	setFormStatus({ message: "Saving..." })

	const saveNotepad_fetch = async () => {
		const response = await fetch(API_BASE + "notepad", {
			method: 'PUT',
			headers: {
				Accept: '*/*',
				'Content-Type': 'text/plain',
				Authorization: 'Bearer ' + token
			},
			body: setText
		});
		if (response.ok) {
			setFormStatus(
				{
					message: "Saved",
					error: false
				}
			)
		} else {
			setFormStatus(
				{
					message: "Problem saving",
					error: true
				}
			)
		}
	}
	
	saveNotepad_fetch();

}


export function api_getEntities(setFormStatus, setEntities, entityType, page, pageSize) {

	setFormStatus("")

	fetch(API_BASE + entityType + "/?pageNo=" + page + "&pagesize=" + pageSize, {
		method: 'GET',
		origin: 'http://localhost:3000',
		headers: {
			Accept: 'application/json',
			Authorization: 'Bearer ' + token,
		}

	}).then((response) => {
		if (response.ok) {
			response.json().then(data => (setEntities(data)))
		} else {
			setFormStatus({ message: "Problem with server response", error: true })
		}
	}, (error) => {
		if (error) {
			setFormStatus({ message: "Problem with server", error: true })
		}
	})
}